declare const window: Window & { dataLayer: Record<string, unknown>[] };

export function getDataLayer() {
  window.dataLayer = window.dataLayer || [];

  return window.dataLayer;
}
